import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LAジャクソンがLondon Rubber Companyを設立し、輸入ゴム製コンドームと附属製品を販売。',
		},
		{
			year: 1929,
			description: 'ロンドン・ラバー・カンパニー（LRC）がDurexブランドを設立。',
		},
		{
			year: '1950s',
			description: '最初の潤滑ゼリー付きコンドームを発売',
		},
		{
			year: 1953,
			description: '製造過程での電子検査を開発。史上初の電子検査実施を達成',
		},
		{
			year: '1990s',
			description: '「Durex Quality」のシールを標準採用。',
		},
		{
			year: 1996,
			description: 'コンドームブランドとして初めてウェブサイトを開設。現在では、42カ国でウェブサイトを開設しています。',
		},
		{
			year: 1998,
			description: 'コンドームブランドとして初めて、世界的な性的幸福度調査を実施し、発表。',
		},
		{
			year: 2005,
			description: 'デュレックス・ネットワークが、研究者や政策立案者向けに性行動を調査したレポート「Face of Global Sex」を発表',
		},
		{
			year: 2008,
			description: '若者の安全なセックスを促進するため、16歳から24歳までの若者にセクシャルヘルスのキャンペーンを実施',
		},
		{
			year: 2009,
			description: 'Durexがブランド生誕より80年',
		},
		{
			year: 2010,
			description: 'ウィーンで開催された国際エイズ会議で、国連人口基金の「コンドーム化！」キャンペーンを支援し、22万個のコンドームを寄付',
		},
		{
			year: 2010,
			description: 'Reckitt Benckiser がDurexを買収',
		},
		{
			year: 2019,
			description: 'Durexがブランド生誕より90年',
		},
	]
}